import React, { useState, useEffect, useRef } from 'react'
import { DownOutlined, UpOutlined } from '@ant-design/icons'
import classNames from 'classnames'
import styles from './index.module.less'

interface MoreProps {
  data?: SwaggerDTO.ProductConfigSpuInfoDTO[]
  onChange?: Function
  value?: string
}

export default function More({ value, data, onChange }: MoreProps) {
  const [active, setActive] = useState('all')
  const [open, setOpen] = useState(false)
  const [showMore, setShowMore] = useState(false)

  const contentRef = useRef<any>()

  useEffect(() => {
    setActive(value || 'all')
  }, [value])

  useEffect(() => {
    if (!data || !contentRef) return
    setShowMore(contentRef.current.scrollHeight > 57)
  }, [data, contentRef])

  return (
    <div className={styles.more} style={open ? { height: 'auto' } : {}}>
      <div className={styles.moreTitle}>分类</div>
      <span className={styles.moreLine}></span>
      <div ref={contentRef} className={styles.moreContent}>
        {data?.map(item => (
          <p
            key={item.productCode}
            className={classNames(
              active === item.productCode && styles.activate
            )}
            onClick={() => {
              setActive(item.productCode)
              onChange?.(item.productCode)
            }}
          >
            {item.product}
          </p>
        ))}
      </div>
      {showMore && (
        <div onClick={() => setOpen(!open)}>
          {!open ? (
            <DownOutlined className={styles.moreIcon} />
          ) : (
            <UpOutlined className={styles.moreIcon} />
          )}
        </div>
      )}
    </div>
  )
}
